import React from 'react'
import { connect } from 'react-redux'
import { doGetPrinterPort, doSavePrinterPort, doDeletePrinterPort } from '../../reducers/actions'

class PrinterPortDiv extends React.Component {
  state = {}

  componentDidMount = () => {
    const { onSave, onClose, dispatch, id } = this.props
    dispatch(doGetPrinterPort({
      id,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, initValues基本信息, changedValues基本信息: {} })
        }
      }
    }))
  }


  handlerConfirm = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    const { onSave, onClose, dispatch } = this.props
    dispatch(doSavePrinterPort({
      id,
      changedValues基本信息,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('保存成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    }))

  }

  handlerDelete = () => {
    const { id } = this.state
    const { onSave, onClose, dispatch } = this.props

    Tyan.pubForm.showConfirm('确定要删除？', () =>
      dispatch(doDeletePrinterPort({
        id,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            Tyan.pubForm.showError(errorMessage)
          }
          else {
            Ext.toast('删除成功')
            onClose && onClose()
            onSave && onSave()
          }
        }
      })))
  }


  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset基本信息 = () => {
    return [
      { _text: '名称', name: '打印机名称', minWidth: '400px' },
      { _text: '地址', name: '地址', minWidth: '400px' },
      { _text: '打印机精度', name: '精度', minWidth: '400px' }]
  }

  render() {
    const { showBody: Body, initValues基本信息, id } = this.props
    return <Body data={this} maxWidth="600"
      controls={
        [
          { _button: '保存', icon: 'save', handler: this.handlerConfirm },
          { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
          { _button: '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(PrinterPortDiv)